import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import './JobRanges.scss';
import { areCurrenciesLoaded, getIsUserReadOnly, getSessionCurrency, isLab } from '../../redux/stateSelectors';
// Components
import { Route } from 'react-router-dom';
import SearchBarMP from '../../SearchBarMP/SearchBarMP';
import JobRangesTable from './JobRangesTable/JobRangesTable';
import LoadingIndicator from '../../LoadingIndicator/LoadingIndicator';
import ModelDetailsPage from './ModelDetailsPage/ModelDetailsPage';
import JobRangesTableEmptyState from './JobRangesTableEmptyState/JobRangesTableEmptyState';
import SlideoutRoot from '../../Slideout/SlideoutRoot';
//actions
import * as jobRangeActions from './actions/JobRanges';

const propTypes = {
  onModelSearchChange: PropTypes.func,
  searchInputValue: PropTypes.string,
  jobRangeModels: PropTypes.array,
  getModelList: PropTypes.func,
  history: PropTypes.object,
  jobRangeModelSearchResults: PropTypes.array,
  modelListLoading: PropTypes.bool,
  clearModelDetails: PropTypes.func,
  resetJobListDetails: PropTypes.func,
  match: PropTypes.object,
  sessionCurrency: PropTypes.object,
  userReadOnly: PropTypes.bool,
  currenciesLoaded: PropTypes.bool,
  isLab: PropTypes.bool
};

class Ranges extends Component {
  componentDidMount() {
    this.props.getModelList();
  }

  componentDidCatch(err, info) {
    console.log('comp err: ', err, info);
  }

  render() {
    const { props } = this;
    const jobRangesRoutes = (
      <div>
        <Route
          path={props.match.url + '/:modelId'}
          render={routeProps => {
            if (props.currenciesLoaded) return <ModelDetailsPage {...props} {...routeProps} />;
            return null;
          }}
          {...props}
        />
        <Route
          exact
          path={props.match.url + '/'}
          render={routeProps => <ModelListPage {...props} {...routeProps} />}
          {...props}
        />
      </div>
    );

    return this.props.isLab ? (
      <div className="generic-page__container container-fluid lab">
        <div className="row div__spacing--header" />
        {jobRangesRoutes}
        <SlideoutRoot />
      </div>
    ) : (
      jobRangesRoutes
    );
  }
}

Ranges.propTypes = propTypes;

const filterByCurrency = (models, currency) => {
  if (currency.id === null) return models;
  return models.filter(model => model.currencyId === currency.id);
};

class ModelListPage extends Component {
  static propTypes = propTypes;

  componentDidMount() {
    this.props.getModelList();
    this.props.clearModelDetails();
    this.props.resetJobListDetails();
  }

  componentWillUnmount() {
    const { pathname } = this.props.history.location;
    if (!pathname.includes('/ranges')) this.props.onModelSearchChange();
  }

  addModel() {
    this.props.history.push('/ranges/add');
  }

  mainContent() {
    const {
      deleteModel,
      jobRangeModels,
      jobRangeModelSearchResults,
      sessionCurrency,
      sortColumn,
      sortDirection,
      preferences
    } = this.props;
    const models = filterByCurrency(jobRangeModelSearchResults || jobRangeModels, sessionCurrency);

    if (models.length) {
      return (
        <JobRangesTable
          deleteModel={deleteModel}
          handleSort={this.props.setSort}
          jobRangeModels={models}
          sortDirection={sortDirection}
          sortField={sortColumn}
          preferences={preferences}
        />
      );
    } else {
      return (
        <JobRangesTableEmptyState
          onAddModelClick={this.addModel.bind(this)}
          showAddModelOption={this.props.userReadOnly === false}
        />
      );
    }
  }

  render() {
    let createNewButton = null;
    if (this.props.userReadOnly === false || this.props.isLab) {
      createNewButton = (
        <a
          className="pxl-btn pxl-btn-primary add__model-button new-range-btn"
          onClick={this.addModel.bind(this)}
          data-test-id="jbr-create-model-button"
        >
          Create New
        </a>
      );
    }

    return (
      <div className="jobRanges jobRanges--container" data-test-id="jbr-main-container">
        <LoadingIndicator loading={this.props.modelListLoading} />
        <div className="ranges__header-row">
          <h1 className="job-ranges__title">Job Based Range</h1>
        </div>
        <div className="ranges__header-row">
          <SearchBarMP
            placeholder="Search by model name or range type"
            onChange={this.props.onModelSearchChange}
            value={this.props.searchInputValue}
          />
          {createNewButton}
        </div>
        {this.mainContent()}
      </div>
    );
  }
}

const connectState = state => {
  let connectedState;
  try {
    connectedState = {
      ...state.jobRanges.jobRanges,
      ...state.jobRanges.modelDetails,
      preferences: state?.session?.user?.preferences,
      sessionCurrency: getSessionCurrency(state),
      currenciesLoaded: areCurrenciesLoaded(state),
      userReadOnly: getIsUserReadOnly(state),
      isLab: isLab(state)
    };
  } catch (err) {
    console.log('state calc error: ', err);
  }

  return connectedState;
};
const actions = { ...jobRangeActions };
export default connect(connectState, actions)(Ranges);
